import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { MagnifyingGlass } from '@phosphor-icons/react';

function SearchBar({
  onChange,
  value,
  containerClassName,
  inputClassName,
  ...otherProps
}) {
  const handleChange = (e) =>
    onChange((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  return (
    <div className={cn('relative flex items-center', containerClassName)}>
      <MagnifyingGlass
        size={16}
        className="absolute left-3 text-neutral-500 pointer-events-none"
        aria-hidden="true"
      />
      <input
        className={cn(
          'h-9 w-[260px] rounded border border-neutral-300 bg-white pl-9 pr-3 text-sm text-neutral-900',
          'placeholder:text-neutral-500',
          'focus:border-brand-600 focus:ring-2 focus:ring-brand-600 focus:ring-offset-2',
          inputClassName,
        )}
        placeholder="Search"
        type="text"
        onChange={handleChange}
        value={value}
        autoComplete="off"
        {...otherProps}
      />
    </div>
  );
}

SearchBar.defaultProps = {
  containerClassName: '',
  inputClassName: '',
};

SearchBar.propTypes = {
  containerClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default SearchBar;
